module.exports = __webpack_public_path__ + "static/media/design9.f148f049.jpg";